import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updatePassword, ValidateEmail } from "../utils";

import {
  Grid,
  Typography,
  TextField,
  Button,
  Link,
  Snackbar,
  CircularProgress
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { withStyles } from "@material-ui/core/styles";

import * as PaymentActions from "../actions/PaymentActions";

const styles = (theme) => ({
  form: {
    padding: "6px 0",
  },
  loginBtn: {
    margin: "0 0 10px 0",
    height: "3rem",
  }
});

const TviTextFiled = withStyles({
  root: {
    "& .MuiInputLabel-root": {
      fontSize: "1.2em",
    },
    "& legend": {
      fontSize: "0.78em",
    },
  },
})(TextField);

const SNACKBAR_INIT_VALUE = {
  open: false,
  type: "error",
  message: ""
};

class ResetPasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      snackbar: SNACKBAR_INIT_VALUE
    };

    this.handleSnackbarClose = this.handleSnackbarClose.bind(this);
    this.onResetPassword = this.onResetPassword.bind(this);
  }

  handleSnackbarClose = () => this.setState({ snackbar: SNACKBAR_INIT_VALUE });

  onResetPassword = () => {
    const { username } = this.state;
    if(ValidateEmail(username)){
      updatePassword(username)
      .then(res =>{
        if (res){
          this.setState({ snackbar: {
            type: "info",
            open: true,
            message: "Your password and further instructions have been sent to your e-mail address."
          } });
        }
        else{
          this.setState({ snackbar: {
            type: "error",
            open: true,
            message: "Reset password failed, Please enter correct email address."
          } });
        }
      })
      .catch(res => {
        this.setState({ snackbar: {
          type: "error",
          open: true,
          message: "Reset password failed, Please enter an registered email address."
        } })
      })
    }else{
      this.setState({ snackbar: {
        type: "error",
        open: true,
        message: "Please enter an email address."
      } });
    }


  }

  render = () => {
    let { state, props, handleSnackbarClose, onResetPassword } = this;
    let { classes, loading, toggleForgotPass } = props;
    let { username, snackbar } = state;

    return (
      <Grid container>
        <Grid item xs={12}>
          <Typography
            style={{ display: "inline-block", textAlign: "right" }}
            variant="body2"
            align="right"
          >
            <Link onClick={toggleForgotPass} style={{ cursor: "pointer", color: "#155E98" }} ><strong>Login</strong></Link>
          </Typography>
        </Grid>

        <Grid item xs={12} style={{ paddingBottom: "8px" }}>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h4" gutterBottom><strong>Reset Password</strong></Typography>
        </Grid>

        <Grid item xs={12} className={classes.form}>
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="stretch"
            spacing={2}
          >
            <Grid item xs={12}>
              <TviTextFiled
                value={username}
                fullWidth
                id="client-reset-uname"
                name="client-reset[uname]"
                label="Email"
                variant="outlined"
                onChange={(e) => this.setState({ username: e.target.value })}
              />
            </Grid>

            <Grid item xs={12}>
              <Button className={classes.loginBtn} variant="contained" color="primary" fullWidth disabled={loading} onClick={onResetPassword}>
                {loading ? <CircularProgress size={20} /> : <Typography variant="h5">Reset</Typography>}
              </Button>
            </Grid>
          </Grid>
        </Grid>
        
        <Snackbar
          open={snackbar.open}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
        >
          <Alert onClose={handleSnackbarClose} severity={snackbar.type} variant="filled"><Typography variant="body2">{snackbar.message}</Typography></Alert>
        </Snackbar>
      </Grid>
    );
  };
}

const mapStateToProps = ({ payment }) => ({
  loading: payment.loading,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(PaymentActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ResetPasswordForm));
